import { IDataLayerZone, ZoneTextLocation } from "../../omnia"
import { EditFeature } from "./edit-feature"

/// <reference path="edit-feature.ts" />

import getGeometryCenter = omnia.map.getGeometryCenter
import { ol_Coordinate, ol_Feature, ol_geom } from "@omnia/exports/openlayers"

export function getDefaultLabelLine(pos: ol_Coordinate | ol_geom.Geometry) {


    const coord = (pos instanceof ol_geom.Geometry)
        ? getGeometryCenter(pos)
        : pos

    const segment = new ol_geom.LineString([
        [coord[0] - 100, coord[1]],
        [coord[0] + 100, coord[1]]
    ])

    return segment

}

export class UndockedLabel extends EditFeature {

    private _initalLabel: string
    private _visible: boolean = true

    constructor(private readonly parent: EditFeature, _zone: IDataLayerZone, _feature?: ol_Feature) {
        super(parent.editLayer, _zone, _feature)
    }

    get label() {
        return this.parent.label
    }

    set label(value: string) {
        this.parent.label = value
    }

    get visible() {
        return this._visible
    }

    set visible(value: boolean) {
        this._visible = value
        this.feature.setStyle(value ? undefined : [])
    }

    canDelete() {
        return false
    }

    shouldSave() {
        return false
    }

    getZoneText(location: ZoneTextLocation) {
        return this.parent.getZoneText(location)
    }

    setInitialState() {
        this.parent.setInitialState()
        this._initalLabel = this.parent.label
        return true
    }

    commitState() {
        this.parent.commitState()
        return true
    }

    cancelChanges() {
        this.label = this._initalLabel
        this.parent.cancelChanges()
        return true
    }

}
